import React from "react";
import "./DownloadProvider.scss";
import DownloadProviderQR from "assets/icons/downloadProvider.svg";
import AppleAppStroreIcon from "assets/icons/appleAppStoreIcon.svg";
import GooglePlayStroreIcon from "assets/icons/googlePlayStoreIcon.svg";

const DownloadProvider = () => {
  return (
    <div id="main-content-target" className="download-provider">
      <div className="title">Streamline Your Workflow</div>
      <div className="description">
        Scan the QR code below to download the app and receive timely patient
        requests
      </div>
      <img
        src={DownloadProviderQR}
        className="download-provider-qr"
        alt="download-provider-qr"
      />
      <div className="app-store-icon">
        <a href="https://apps.apple.com/my/app/bookdoc-for-providers/id1460359883">
          <img src={AppleAppStroreIcon} alt="apple-app-store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.bookdoc.doctor&hl=en&gl=US">
          <img src={GooglePlayStroreIcon} alt="google-play-store" />
        </a>
      </div>
    </div>
  );
};
export default DownloadProvider;
